const dealFilters = {
  "Toyota": [
    {
      vehicle: "2026 Toyota Camry",
      trim_package: "LE",
      img: "https://www.buyatoyota.com/sharpr/vcr/adobe/assets/urn:aaid:aem:16726f27-0022-4fc4-9c62-b540a2c97285/as/image.png?",
      down_payment: "$0",
      payment: "$399",
      months: "36",
      disclosure: "Terms available on approved credit through Toyota Financial Services (TFS). Not all customers qualify.",
    },
    {
      vehicle: "2026 Toyota Camry",
      trim_package: "SE",
      img: "https://cdn.sanity.io/images/90qxor39/production/be133fee02dbda1a6f06cb63839385994330aa63-882x344.png?w=882&h=344&q=75&fit=max&auto=format",
      down_payment: "$0",
      payment: "$439",
      months: "36",
      disclosure: "Terms available on approved credit through Toyota Financial Services (TFS). Not all customers qualify.",
    },
    {
      vehicle: "2026 Toyota Corolla",
      trim_package: "LE",
      img: "https://tmna.aemassets.toyota.com/is/image/toyota/toyota/jellies/max/2026/corolla/le/1852/1k3/1.png?fmt=png-alpha&wid=930&hei=328&qlt=90",
      down_payment: "$0",
      payment: "$339",
      months: "36",
      disclosure: "Terms available on approved credit through Toyota Financial Services (TFS). Not all customers qualify.",
    },
    {
      vehicle: "2026 Toyota Corolla",
      trim_package: "SE",
      img: "https://www.buyatoyota.com/sharpr/bat/assets/img/vehicle-info/Corolla/2026/hero-image.png",
      down_payment: "$0",
      payment: "$369",
      months: "36",
      disclosure: "Terms available on approved credit through Toyota Financial Services (TFS). Not all customers qualify.",
    },
    {
      vehicle: "2026 Toyota Corolla",
      trim_package: "LE Hybrid",
      img: "https://www.buyatoyota.com/sharpr/bat/assets/img/vehicle-info/Corolla_Hybrid/2026/hero-image.png",
      down_payment: "$0",
      payment: "$385",
      months: "36",
      disclosure: "Terms available on approved credit through Toyota Financial Services (TFS). Not all customers qualify.",
    },
    {
      vehicle: "2026 Toyota Prius",
      trim_package: "LE",
      img: "https://www.buyatoyota.com/sharpr/bat/assets/img/vehicle-info/Prius/2026/hero-image.png",
      down_payment: "$0",
      payment: "$479",
      months: "36",
      disclosure: "Terms available on approved credit through Toyota Financial Services (TFS). Not all customers qualify.",
    },
    {
      vehicle: "2026 Toyota Prius",
      trim_package: "XLE",
      img: "https://tmna.aemassets.toyota.com/is/image/toyota/toyota/jellies/max/2026/priuspluginhybrid/xse/1237/1m2/36/5.png?fmt=png-alpha&wid=930&hei=328&qlt=90",
      down_payment: "$0",
      payment: "$529",
      months: "36",
      disclosure: "Terms available on approved credit through Toyota Financial Services (TFS). Not all customers qualify.",
    },
    {
      vehicle: "2026 Toyota RAV4",
      trim_package: "LE",
      img: "https://tmna.aemassets.toyota.com/is/image/toyota/toyota/jellies/max/2026/rav4/le/4521/4v8/1.png?fmt=png-alpha&wid=930&hei=328&qlt=90",
      down_payment: "$0",
      payment: "$529",
      months: "36",
      disclosure: "Terms available on approved credit through Toyota Financial Services (TFS). Not all customers qualify.",
    },
    {
      vehicle: "2026 Toyota RAV4",
      trim_package: "XLE",
      img: "https://www.buyatoyota.com/sharpr/bat/assets/img/vehicle-info/RAV4/2026/hero-image.png",
      down_payment: "$0",
      payment: "$575",
      months: "36",
      disclosure: "Terms available on approved credit through Toyota Financial Services (TFS). Not all customers qualify.",
    },
    {
      vehicle: "2026 Toyota RAV4",
      trim_package: "XSE",
      img: "https://delivery.via.assetscs.toyota.com/adobe/assets/urn:aaid:aem:2a7d4cae-5004-4959-83cf-1a89a0189fdb/as/image.png?fmt=png-alpha,rgb,none",
      down_payment: "$0",
      payment: "$629",
      months: "36",
      disclosure: "Terms available on approved credit through Toyota Financial Services (TFS). Not all customers qualify.",
    },
  ],
};

export default dealFilters;